'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HistoricTable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _reactRouter = require('react-router');

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _join = require('lodash/join');

var _join2 = _interopRequireDefault(_join);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _split = require('lodash/split');

var _split2 = _interopRequireDefault(_split);

var _SimpleTable = require('./SimpleTable');

var _SimpleTable2 = _interopRequireDefault(_SimpleTable);

var _newStatePageReset = require('./newStatePageReset');

var _newStatePageReset2 = _interopRequireDefault(_newStatePageReset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_PAGE_SIZE = 50;
var QUERY_FIELDS = ['from', 'pgsz', 'sortKey', 'sortDir', 'filter'];
var WATCHED_QUERY_PARAMETERS = [].concat(QUERY_FIELDS, ['hide']);

var parseSearch = function parseSearch(search) {
    search = search.replace(/^\?/, '');
    return _querystring2.default.parse(search);
};
var newQueryString = function newQueryString(newQuery) {
    var query = parseSearch(location.search);
    return _querystring2.default.stringify(Object.assign({}, query, newQuery));
};

var HistoricTable = exports.HistoricTable = function (_React$Component) {
    _inherits(HistoricTable, _React$Component);

    function HistoricTable(props) {
        _classCallCheck(this, HistoricTable);

        var _this = _possibleConstructorReturn(this, (HistoricTable.__proto__ || Object.getPrototypeOf(HistoricTable)).call(this, props));

        _this.state = {
            from: 0,
            pgsz: DEFAULT_PAGE_SIZE
        };
        return _this;
    }

    _createClass(HistoricTable, [{
        key: 'replaceUrl',
        value: function replaceUrl(path, newQuery) {
            this.props.history.replace(path + '?' + newQueryString(newQuery));
        }
    }, {
        key: 'updateUrl',
        value: function updateUrl(path, newQuery) {
            this.props.history.push(path + '?' + newQueryString(newQuery));
        }
    }, {
        key: 'newProperties',
        value: function newProperties(location) {
            var query = parseSearch(location.search);
            var newState = {
                from: parseInt(query.from, 10) || 0,
                pgsz: parseInt(query.pgsz, 10) || DEFAULT_PAGE_SIZE,
                sortKey: query.sortKey || this.props.defaultSortKey,
                sortDir: query.sortDir || this.props.defaultSortDir,
                filter: query.filter || ''
            };
            this.replaceUrl(location.pathname, newState);
            if (!(0, _isEmpty2.default)((0, _pick2.default)(query, QUERY_FIELDS))) {
                this.props.onTableChange({
                    from: newState.from,
                    pageSize: newState.pgsz,
                    sortKey: newState.sortKey,
                    sortDir: newState.sortDir,
                    filter: newState.filter
                });
            }
            if (!(0, _isUndefined2.default)(this.props.onChangeColumnVisibility) && !(0, _isEmpty2.default)(query.hide)) {
                var hiddenColumns = (0, _map2.default)((0, _filter2.default)(this.props.columnDefs, { display: false }), 'key');
                var hideArray = (0, _split2.default)(query.hide, ',');
                if (!(0, _isEqual2.default)(hideArray, hiddenColumns)) {
                    this.props.onChangeColumnVisibility(hideArray);
                }
            }
            this.setState(newState);
        }
    }, {
        key: 'hideColumns',
        value: function hideColumns(hiddenColumns) {
            this.replaceUrl(location.pathname, Object.assign({}, this.state, {
                hide: (0, _join2.default)(hiddenColumns, ',')
            }));
            this.props.onChangeColumnVisibility(hiddenColumns);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.newProperties(this.props.location);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var hasParametersChanged = !(0, _isEqual2.default)((0, _pick2.default)(parseSearch(prevProps.location.search), WATCHED_QUERY_PARAMETERS), (0, _pick2.default)(parseSearch(this.props.location.search), WATCHED_QUERY_PARAMETERS));
            var hasNewRecords = !(0, _isEqual2.default)((0, _pick2.default)(prevProps, ['total', 'records']), (0, _pick2.default)(this.props, ['total', 'records']));
            var hasWrongPage = (this.state.pgsz !== 0 || this.props.total > 0) && this.props.records.length === 0;
            if (hasParametersChanged) {
                this.newProperties(this.props.location);
            } else if (hasNewRecords && hasWrongPage) {
                var newState = _newStatePageReset2.default.getState(this.props);
                this.replaceUrl(location.pathname, newState);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                location = _props.location,
                rest = _objectWithoutProperties(_props, ['location']);

            return _react2.default.createElement(_SimpleTable2.default, Object.assign({}, rest, {
                from: this.state.from,
                pageSize: this.state.pgsz,
                sortKey: this.state.sortKey,
                sortDir: this.state.sortDir,
                filter: this.state.filter,
                onChangeColumnVisibility: this.props.onChangeColumnVisibility ? function (hiddenColumns) {
                    return _this2.hideColumns(hiddenColumns);
                } : undefined,
                onPageChange: function onPageChange(newPageNumber) {
                    _this2.updateUrl(location.pathname, Object.assign({}, _this2.state, {
                        from: _this2.state.pgsz * (newPageNumber - 1)
                    }));
                },
                onSortChange: function onSortChange(sortKey, sortDir) {
                    _this2.updateUrl(location.pathname, Object.assign({}, _this2.state, {
                        from: 0,
                        sortKey: sortKey,
                        sortDir: sortDir || _this2.props.defaultSortDir
                    }));
                },
                onFilterChange: function onFilterChange(filter) {
                    _this2.updateUrl(location.pathname, Object.assign({}, _this2.state, {
                        from: 0,
                        filter: filter
                    }));
                },
                onPageSizeChange: function onPageSizeChange(pgsz) {
                    _this2.updateUrl(location.pathname, Object.assign({}, _this2.state, {
                        from: 0,
                        pgsz: pgsz
                    }));
                }
            }));
        }
    }]);

    return HistoricTable;
}(_react2.default.Component);

HistoricTable.propTypes = Object.assign({}, _SimpleTable2.default.propTypes, {
    defaultSortKey: _propTypes2.default.string,
    defaultSortDir: _propTypes2.default.string,
    location: _propTypes2.default.object.isRequired,
    history: _propTypes2.default.object.isRequired,
    onTableChange: _propTypes2.default.func.isRequired,
    onChangeColumnVisibility: _propTypes2.default.func
});

exports.default = (0, _reactRouter.withRouter)(HistoricTable);
//# sourceMappingURL=HistoricTable.js.map